import React, { useEffect, useState } from "react";
import {
  addCrewEquipment,
  getAllEquipmentList,
  getCrewEquipmentById,
} from "../API";
import { toast } from "react-toastify";
import icon1 from "../assets/images/numberSort.png";
import icon2 from "../assets/images/alphabetSort.png";
import iconAlpha from "../assets/images/alphabetSort-blue.png";
import iconNum from "../assets/images/numberSort-blue.png";

const AddNewEquipmentModal = (props) => {
  const {
    crew_id,
    crewEquipments,
    toggleAddNewEquipment,
    setToggleAddNewEquipment,
    allSelectedEquipments,
    setAllSelectedEquipments,
  } = props;

  const [addEquipmentList, setAddEquipmentList] = useState([]);
  const [isNotSelected, setIsNotSelected] = useState(true);
  const [selectedEquipment, setSelectedEquipment] = useState({});
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [hoverImage, setHoverImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const crewTableHeadings = [
    {
      img: icon2,
      label: "Item",
      sortBy: "name",
      hoverImg: iconAlpha,
    },
    {
      img: icon1,
      label: "Equipment Number",
      sortBy: "number",
      hoverImg: iconNum,
    },
  ];

  const handleMouseEnter = (index) => {
    setHoverImage(index);
  };
  const handleMouseLeave = (index) => {
    setHoverImage(null);
  };

  const getAllEquipments = async () => {
    try {
      setIsLoading(true);
      await getAllEquipmentList().then((res) => {
        if (res?.status === 200) {
          const filteredEquipments = res?.data
            .filter((equipmentItem) => {
              const crewEquipment = crewEquipments?.find(
                (crewEquipment) =>
                  crewEquipment?.value?.equipment_id === equipmentItem?.id
              );
              return equipmentItem?.name !== crewEquipment?.label;
            })
            ?.filter((equipmentItem) => {
              const selectedEquipment = allSelectedEquipments?.find(
                (ele) => equipmentItem?.id === ele?.value?.equipment_id
              );
              return (
                selectedEquipment?.value?.equipment_id !== equipmentItem?.id
              );
            });
          setAddEquipmentList(filteredEquipments);
        }
      });
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (toggleAddNewEquipment) {
      getAllEquipments();
    }
  }, [toggleAddNewEquipment]);

  const handleSort = (column) => {
    setSortColumn(column);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const sortedEquipmentList = [...addEquipmentList].sort((a, b) => {
    const valueA = sortColumn === "name" ? a.name : a.acumatica_id;
    const valueB = sortColumn === "name" ? b.name : b.acumatica_id;

    if (sortOrder === "asc") {
      return valueA.localeCompare(valueB);
    } else {
      return valueB.localeCompare(valueA);
    }
  });

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredEquipmentList = sortedEquipmentList.filter(
    (item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.acumatica_id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const onSubmitEquipment = async (selectedItem) => {
    setIsLoading(true);
    const crewEquipmentPayload = {
      crew_id,
      equipment_id: selectedItem?.id,
    };
    const equipmentPayload = {
      ...crewEquipmentPayload,
      type: "adhoc",
    };
    await getCrewEquipmentById(crewEquipmentPayload).then(async (res) => {
      setIsLoading(false);
      if (res?.data?.length > 0) {
        const addedEquipment = {
          label: `(${res?.data[0]?.equipment?.acumatica_id || "NA"}) ${
            res?.data[0]?.equipment?.name
          }`,
          value: {
            id: res?.data[0]?.id,
            equipment_id: res?.data[0]?.equipment?.id,
          },
        };
        setAllSelectedEquipments((prevState) => [...prevState, addedEquipment]);
        setToggleAddNewEquipment(false);
        setSelectedEquipment(true);
        setSearchTerm("");
        setIsNotSelected(true);
        toast.success("New equipment successfully added");
      } else {
        await addCrewEquipment(equipmentPayload)
          .then(async (res) => {
            setIsLoading(false);
            if (res?.status === 200) {
              const crewEquipmentPayload = {
                id: res?.data?.id,
              };
              await getCrewEquipmentById(crewEquipmentPayload).then((res) => {
                const addedEquipment = {
                  label: `(${res?.data[0]?.equipment?.acumatica_id || "NA"}) ${
                    res?.data[0]?.equipment?.name
                  }`,
                  value: {
                    id: res?.data[0]?.id,
                    equipment_id: res?.data[0]?.equipment?.id,
                  },
                };
                setAllSelectedEquipments((prevState) => [
                  ...prevState,
                  addedEquipment,
                ]);
                setToggleAddNewEquipment(false);
                setSelectedEquipment(true);
                setSearchTerm("");
                setIsNotSelected(true);
                // fetchEquipmentList();
                toast.success("New equipment successfully added");
              });
            }
          })
          .catch((err) => {
            toast.error("Unable to add equipment");
            setIsLoading(false);
          });
      }
    });
  };

  return (
    <>
      <div
        className="modal add-new-equipment-modal fade"
        id="addNewEquipment"
        tabIndex="-1"
        aria-labelledby="addNewEquipmentLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title font-weight-bold"
                id="addNewEquipmentLabel"
              >
                Add New Equipment
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setToggleAddNewEquipment(false);
                  setSelectedEquipment(true);
                  setSearchTerm("");
                  setIsNotSelected(true);
                }}
              ></button>
            </div>
            <div className="modal-body">
              <>
                <div className="search-bar mb-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>
                {filteredEquipmentList.length > 0 && (
                  <div className="table-responsive">
                    <table className="table crew-modal-table eqp-table">
                      <thead>
                        <tr>
                          {crewTableHeadings?.length > 0 &&
                            crewTableHeadings?.map((item, index, key) => (
                              <th
                                scope="col"
                                className={`heading ${
                                  index === 1 ? "heading2" : ""
                                }`}
                                key={key}
                              >
                                {item.label}
                                <img
                                  onClick={() => handleSort(item.sortBy)}
                                  onMouseEnter={() => handleMouseEnter(index)}
                                  onMouseLeave={handleMouseLeave}
                                  src={
                                    hoverImage === index
                                      ? item.hoverImg
                                      : item.img
                                  }
                                  className="img-fluid icon ml-3"
                                  alt=""
                                />
                              </th>
                            ))}
                        </tr>
                      </thead>
                      {!isLoading && (
                        <tbody>
                          {filteredEquipmentList.map((item, key) => {
                            return (
                              <tr
                                className={
                                  selectedEquipment.id === item.id
                                    ? "activeRow"
                                    : ""
                                }
                                onClick={() => {
                                  setSelectedEquipment(item);
                                  setIsNotSelected(false);
                                }}
                                key={key}
                              >
                                <td>{item.name}</td>
                                <td>{item.acumatica_id}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      )}
                    </table>
                  </div>
                )}
              </>
            </div>
            <div
              className="modal-footer"
              style={{ justifyContent: "space-between" }}
            >
              <div>
                {isLoading && (
                  <div className="ddd">
                    <div className="spinner-border" role="status"></div>
                  </div>
                )}
              </div>
              <button
                disabled={isNotSelected}
                data-bs-dismiss="modal"
                type="button"
                className={
                  !isNotSelected ? "primary-btn" : "disabled-submit-btn"
                }
                aria-label="Close"
                onClick={() => onSubmitEquipment(selectedEquipment)}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNewEquipmentModal;
